<nav
  class="breadcrumb"
  [ngClass]="{
    breadcrumb_transparent: transparent,
    'image-overlay': imageOverlay,
    standard_max_width: standard_max_width,
    dark_backdrop: dark_backdrop,
    isVertical: vertical
  }"
>
  <ul
    class="breadcrumb_list"
    [ngClass]="{
      vertical: vertical,
      noPaddingLeftAndTopMobile: noPaddingLeftAndTopMobile
    }"
  >
    <li class="breadcrumb_list_item">
      <a class="breadcrumb_link" routerLink="/" href="/">
        <span class="breadcrumb_span">
          {{ 'NAVIGATION.TXT.HOME' | translate }}
        </span>
      </a>
      <span class="breadcrumb_seperator"> / </span>
    </li>
    @for (part of partsOfUrl; track $index) {
      <li class="breadcrumb_list_item">
        <a
          class="breadcrumb_link"
          [href]="part.url"
          [ngClass]="{ active_site: $index === partsOfUrl.length - 1 }"
        >
          <span
            class="breadcrumb_span"
            [ngClass]="{ active_site: $index === partsOfUrl.length - 1 }"
          >
            {{ capitalizeFirstLetter(part.name) }}
          </span>
        </a>
        @if ($index !== partsOfUrl.length - 1) {
          <span class="breadcrumb_seperator"> / </span>
        }
      </li>
    }
  </ul>
</nav>
